import { render } from "./HtmlFilePreview.vue?vue&type=template&id=15f5e8ca"
import script from "./HtmlFilePreview.vue?vue&type=script&lang=js"
export * from "./HtmlFilePreview.vue?vue&type=script&lang=js"

import "./HtmlFilePreview.vue?vue&type=style&index=0&id=15f5e8ca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__